/**
 * SDICSP-73 — Scroll lock safety net
 * Multiple sources can lock body scroll: Shopify's privacy banner (inline
 * style), the mobile menu (classList), and the cart drawer (Alpine store).
 * If any of these fail to clean up, the page becomes permanently locked.
 * This observer detects orphaned locks and removes them.
 */
(() => {
  const PREFS_ID = 'shopify-pc__prefs';
  const BANNER_ID = 'shopify-pc__banner';
  let pendingTimeout = null;

  const isLockIntentional = () => {
    // Privacy preferences modal is open
    const prefs = document.getElementById(PREFS_ID);
    if (prefs && getComputedStyle(prefs).display !== 'none') return true;

    // Privacy banner is open
    const banner = document.getElementById(BANNER_ID);
    if (banner && getComputedStyle(banner).display !== 'none') return true;

    // Cart drawer or general overflow is active (Alpine store)
    if (window.Alpine) {
      if (Alpine.store('cartDrawerStore')?.cartDrawOpen) return true;
      if (Alpine.store('bodyOverflowHidden')?.enabled) return true;
    }

    // Mobile menu is open
    const header = document.querySelector('[x-data="header"]');
    if (header?.__x?.$data?.mobileMenuOpen) return true;

    // Check older Alpine v2 data stack if __x.$data isn't available
    if (header?._x_dataStack?.some((data) => data.mobileMenuOpen)) return true;

    return false;
  };

  const checkAndClean = () => {
    const hasInline = document.body.style.overflow === 'hidden';
    const hasClass = document.body.classList.contains('overflow-hidden');

    if (!hasInline && !hasClass) return;
    if (isLockIntentional()) return;

    if (hasInline) document.body.style.removeProperty('overflow');
    if (hasClass) document.body.classList.remove('overflow-hidden');
  };

  const observer = new MutationObserver(() => {
    // Debounce — let legitimate locks settle before checking
    if (pendingTimeout) clearTimeout(pendingTimeout);
    pendingTimeout = setTimeout(checkAndClean, 300);
  });

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['style', 'class'],
  });

  // Fallback: wrapper removal is a child-node mutation, not a body
  // attribute change, so the observer alone may miss it.
  setInterval(checkAndClean, 2000);
})();
